import { OrdemServicoService } from "src/app/services/ordem-servico.service";
import { Component, Input, OnInit, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from "@angular/core";
import { EnumStatusSafra, Safra } from "src/app/classes/Safra";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageService } from "src/app/services/storage.service";
import Swal from "sweetalert2";
import { CustomToastyService } from "src/app/theme/shared/components/toasty/custom-toasty.service";
import { Cultura } from "src/app/classes/Cultura";
import { CulturaService } from "src/app/services/cultura.service";
import { AnoSafra, EnumStatusAnoSafra } from "src/app/classes/AnoSafra";
import { AnoSafraService } from "src/app/services/ano-safra.service";
import {
  EnumStatusPlanejmento,
  Planejamento,
} from "src/app/classes/Planejamento";
import { Area } from "src/app/classes/Area";
import { AreaService } from "src/app/services/area.service";
import { Fazenda } from "src/app/classes/Fazenda";
import { FazendaService } from "src/app/services/fazenda.service";
import { Cultivar } from "src/app/classes/Cultivar";
import { CultivarService } from "src/app/services/cultivar.service";
import { PlanejamentoService } from "src/app/services/planejamento.service";
import { UiModalComponent } from "src/app/theme/shared/components/modal/ui-modal/ui-modal.component";
import { UtilsService } from "src/app/utils/utils.service";
import { SafraService } from "src/app/services/safra.service";
import { TranslateService } from "@ngx-translate/core";
import {
  ColumnModel,
  Aggregate,
  ForeignKeyService,
  PageSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { ListaProjetosCulturaComponent } from "./projeto/lista-projetos-cultura/lista-projetos-cultura.component";
import { SyncGridComponent } from "../../shared-farm/sync-grid/sync-grid.component";
import { PlanejamentoDeleteListResponse } from "src/app/classes/auxiliar/DeletePlanejamentoListResponse";
import { TalhoesComponent } from "./talhoes/talhoes.component";
import { SafraTabLateralComponent } from "./safra-tab-lateral/safra-tab-lateral.component";

@Component({
  selector: "app-safra",
  templateUrl: "./safra.component.html",
  styleUrls: ["./safra.component.scss"],
  providers: [ForeignKeyService],
})
export class SafraComponent implements OnInit, AfterViewInit {
  @ViewChild("ModalSimular", { static: false })
  ModalSimular: UiModalComponent;
  @ViewChild("ModalConfigurar", { static: false })
  ModalConfigurar: UiModalComponent;
  @ViewChild("ModalSimularSafra", { static: false })
  ModalSimularSafra: UiModalComponent;
  @ViewChild("listaProjetos", { static: false })
  listaProjetos: ListaProjetosCulturaComponent;
  @ViewChild("gridTalhoes", { static: false })
  gridTalhoes: SyncGridComponent;
  @ViewChild(TalhoesComponent, { static: false })
  talhoesComponent: TalhoesComponent;
  @ViewChild("safraTabLateral", { static: false })
  safraTabLateral: SafraTabLateralComponent;

  _carregando: boolean = false;
  get carregando(): boolean {
    return this._carregando;
  }

  set carregando(valor: boolean) {
    this._carregando = valor;
  }
  anosSafras: AnoSafra[];
  fazendas: Fazenda[] = [];
  culturas: Cultura[] = [];
  cultivares: Cultivar[] = [];
  usaProjetos: boolean = false;
  talhoesColumns: ColumnModel[] = [];
  removendo: boolean = false;
  iniciandoTalhoes: boolean = false;
  safraSelecionada: Safra;
  anoSafraSelecionada: AnoSafra;
  culturaSelecionada: Cultura;
  planejamentos: Planejamento[] = [];
  auxPlanejamentos: Planejamento[] = [];
  areas: Area[];
  areaTotalSafra: number = 0;

  fazenda: Fazenda;

  filtroStatus: number = 0;
  filtroArea: number = 0;
  filtroIrrigado: number = 0;

  filtroStatusAtivo: string = "Por status";
  filtroAreaAtivo: string = "Por área";
  filtroIrrigadoAtivo: string = "Por tipo de área";

  planejamentoSimulado: Planejamento = new Planejamento();
  planejamentoConfigurado: Planejamento = new Planejamento();
  planejamentoExcluido: Planejamento = new Planejamento();
  planosMestre: Planejamento[];
  public isSubmit: boolean;
  perfilUsuario: number = 0;
  mostraEdicaoSafra: boolean = false;
  informarPlantio: boolean = false;
  statusNaoIniciada: number = EnumStatusSafra.NaoIniciada;
  anoSafraId: number
  divHeight: number
  gridHeight: string = '79vh';
  desabilitarAcoes: boolean = false;
  get divHeightPx(): string {
    return `${this.divHeight}px`
  }

  footerCalc: boolean = false

  aggregateOptions = [
    {
      columns: [
        {
          field: 'CustoPorHA',
          type: 'Sum',
          format: 'C2',
          footerTemplate: '${Sum}'
        },
        {
          field: 'AreaPlantada',
          type: 'Sum',
          format: 'N2',
          footerTemplate: '${Sum}'
        }
      ]
    }
  ];

  // tradução
  SIM: string = "Sim";
  NAO: string = "Não";
  VOCE_SERA_REDIRECIONADO_PARA_A_TELA_DE_ORDENS_DE_SERVICO_: string =
    "Você será redirecionado para a tela de Ordens de Serviço, ";
  ACESSAR_ORDENS_DE_SERVICO: string = "Acessar Ordens de Serviço?";
  ORDENS_DE_SERVICO_GERADAS_COM_SUCESSO: string =
    "Ordens de Serviço geradas com sucesso";
  TODAS_AS_ORDENS_DE_SERVICO_DESSA_SAFRA_FORAM_GERADAS: string =
    "Todas as Ordens de Serviço dessa Safra foram geradas";
  CANCELAR: string = "Cancelar";
  AO_INICIAR_A_SAFRA_TODAS_AS_ORDENS_DE_SERVICO_SERAO_GERADAS_BASEADO_NOS_DIAS_DE_REFERENCIA_E_NA_PREVISAO_DE_PLANTIO_DESEJA_CONTINUAR: string =
    "Ao iniciar a safra, todas as Ordens de Serviço serão geradas baseado nos Dias de Referência e na Previsão de Plantio. Deseja continuar?";
  INICAR_SAFRA: string = "Iniciar safra?";
  SAFRA_JA_INICIADA: string = "Safra já iniciada!";
  ATENCAO: string = "Atenção!";
  NENHUMA_SAFRA_SELECIONADA: string = "Nenhuma safra selecionada!";
  PLANTIO_ENCERRADO: string = "Plantio encerrado!";
  FEITO: string = "Feito!";
  OS_EXCLUIDAS_COM_SUCESSO: string = "OS Excluídas com sucesso";
  TODAS_AS_OS_DESSA_SAFRA_FORAM_EXCLUIDAS: string =
    "Todas as O.S. dessa safra foram Excluídas";
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string =
    "Se deletar, esta ação não poderá ser desfeita!";
  DELETAR_TODAS_OS_DESSA_SAFRA: string = "Deletar todas O.S. dessa safra?";
  OS_GERADAS_COM_SUCESSO: string = "OS Geradas com sucesso";
  TODAS_AS_OS_DESSA_SAFRA_FORAM_GERADAS: string =
    "Todas as O.S. dessa safra foram geradas";
  ESSA_ACAO_PODERA_LEVAR_UM_TEMPO_E_SUBSTITUIR_AS_OS_JA_EXISTENTES: string =
    "Essa ação poderá levar um tempo e substituir as O.S. já existentes!";
  GERAR_TODAS_OS_DESSA_SAFRA: string = "Gerar todas O.S. dessa safra?";
  SEQUEIRO: string = "Sequeiro";
  IRRIGADO: string = "Irrigado";
  POR_TIPO_DE_AREA: string = "Por tipo de área";
  POR_AREA: string = "Por área";
  NAO_CONFIGURADOS: string = "Não configurados";
  CONFIGURADOS: string = "Configurados";
  POR_STATUS: string = "Por status";

  constructor(
    private areaService: AreaService,
    private anoSafraService: AnoSafraService,
    private fazendaService: FazendaService,
    private culturaService: CulturaService,
    private cultivarService: CultivarService,
    private ordemServicoService: OrdemServicoService,
    private planejamentoService: PlanejamentoService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private utils: UtilsService,
    private safraService: SafraService,
    private translate: TranslateService
  ) {

   }

  ngOnInit() {
    this.carregando = true;
    this.usaProjetos = this.storageService.getEmpresa().UsaProjetos;
    this.anoSafraService.anoSafraSelecionado = null;
    this.perfilUsuario = this.storageService.getUsuario().Perfil;
    this.informarPlantio = this.router.url.includes("informar-plantio");

    // Inicializar colunas básicas imediatamente
    this.inicializarColunasBasicas();

    const anoSafraIdSalvo = localStorage.getItem('ultimoAnoSafraSelecionado');
    if (anoSafraIdSalvo) {
      this.anoSafraId = parseInt(anoSafraIdSalvo);
    }

    var fazenda = this.storageService.getFazenda();
    this.anoSafraService
      .getAnosSafrasPorFazenda(fazenda.Id)
      .subscribe((ret) => {
        this.anosSafras = ret;
      });

    this.areaService.getAreas().subscribe((ret) => {
      this.areas = ret;
    });

    this.fazendaService.getFazendas().subscribe((ret) => {
      this.fazendas = ret;
    });

    this.cultivarService.getCultivares().subscribe((ret) => {
      this.cultivares = ret;
      this.prepararGrid();
    });

    this.culturaService.getCulturas().subscribe((ret) => {
      this.culturas = ret;
      this.prepararGrid();
    });
  }

  ngAfterViewInit(): void {
    this.getDivHeight();
  }

  inicializarColunasBasicas(): void {
    // Colunas básicas que não dependem de dados externos
    this.talhoesColumns = [
      { type: "checkbox", width: 50 },
      { field: "DescricaoArea", headerText: "Talhão", allowSorting: true },
      {
        field: "AreaPlantada",
        headerText: "Área Plantada (ha)",
        allowSorting: true,
      },
      {
        field: "DescricaoPlanoMestreProducao",
        headerText: "Plano Agronômico",
        allowSorting: true,
      },
      {
        field: "DataPrevistaPlantio",
        headerText: "Prev. de Plantio",
        type: "date",
        format: { type: 'date', format: 'dd/MM/yyyy' },
        allowSorting: true,
      },
      {
        field: "DataPrevistaColheita",
        headerText: "Prev. de Colheita",
        type: "date",
        format: { type: 'date', format: 'dd/MM/yyyy' },
        allowSorting: true,
      },
      {
        field: "CustoPorHA",
        headerText: "Custo/Ha",
        allowSorting: true,
        valueAccessor: (_field: string, _data: Planejamento): any => {
          return `R$ ${this.utils.formatarDecimais(_data.CustoPorHA)}`;
        },
      },
      {
        field: "DescricaoStatus",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        valueAccessor: (_field: string, _data: Planejamento): any => {
          return this.badgeStatusPlanejamento(_data.Status);
        },
      },
    ];
  }

  getDivHeight(): void {

    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
      const headerGridTalhoes = document.querySelector('.container-talhoes div.bg-white.border.header-grid-talhoes') as HTMLElement
      const groupdroparea = document.querySelector('.container-talhoes div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
      const toolbar = document.querySelector('.container-talhoes div.custom-toolbar.justify-content-between') as HTMLElement
      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;

      const footerAggregate = 40;

      const altura = window.innerHeight - navbar.offsetHeight - headerGridTalhoes.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - footerAggregate - 60
      this.gridHeight = `${altura}px`
    }, 100);

  }

  onSalvarTalhoesEvento() {
    this.listarPlanejamentos();
  }

  onOperacaoAnoSafra(isLoading: boolean) {
    this.carregando = isLoading;
  }

  prepararGrid(): void {
    this.talhoesColumns = [
      { type: "checkbox", width: 50 },
      { field: "DescricaoArea", headerText: "Talhão", allowSorting: true },
      {
        field: "AreaPlantada",
        headerText: "Área Plantada (ha)",
        allowSorting: true,
      },
      {
        field: "CulturaId",
        headerText: "Cultura",
        allowSorting: true,
        foreignKeyField: "Id",
        foreignKeyValue: "Descricao",
        dataSource: this.culturas,
      },
      {
        field: "CultivarId",
        headerText: "Variedade",
        allowSorting: true,
        foreignKeyField: "Id",
        foreignKeyValue: "Descricao",
        dataSource: this.cultivares,
      },
      {
        field: "DescricaoPlanoMestreProducao",
        headerText: "Plano Agronômico",
        allowSorting: true,
      },
      {
        field: "CultivarId",
        headerText: "Ciclo",
        allowSorting: true,
        foreignKeyField: "Id",
        foreignKeyValue: "Ciclo",
        dataSource: this.cultivares,
      },
      {
        field: "DataPrevistaPlantio",
        headerText: "Prev. de Plantio",
        type: "date",
        format: { type: 'date', format: 'dd/MM/yyyy' },
        allowSorting: true,
      },
      {
        field: "DataPrevistaColheita",
        headerText: "Prev. de Colheita",
        type: "date",
        format: { type: 'date', format: 'dd/MM/yyyy' },
        allowSorting: true,
      },
      {
        field: "CustoPorHA",
        headerText: "Custo/Ha",
        allowSorting: true,
        valueAccessor: (_field: string, _data: Planejamento): any => {
          return `R$ ${this.utils.formatarDecimais(_data.CustoPorHA)}`;
        },
      },
      {
        field: "DescricaoStatus",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        valueAccessor: (_field: string, _data: Planejamento): any => {
          return this.badgeStatusPlanejamento(_data.Status);
        },
      },
    ];
    if (this.usaProjetos)
      this.talhoesColumns.splice(3, 0, { field: "DescricaoSafra", headerText: "Projeto", allowSorting: true, visible: false });
  }

  attListaAnosSafras(lista: AnoSafra[]): void {
    this.anosSafras = lista;
    this.desabilitarAcoes = false;
  }
  selecionarAnoSafra(anoSafra: AnoSafra): void {
    if (anoSafra.Id) {
      this.anoSafraId = anoSafra.Id;
      localStorage.setItem('ultimoAnoSafraSelecionado', anoSafra.Id.toString());
    }
    this.culturaSelecionada = null;
    this.anoSafraService.getAnoSafra(anoSafra.Id).subscribe((res) => {
      this.anoSafraSelecionada = res;
      this.planejamentos = [];
      this.carregando = false;
      this.listarPlanejamentos()
    });
  }

  changeAnoSafra(anoSafraId: number): void {
    const anoSafra = this.anosSafras.find(p => p.Id == anoSafraId);
    this.safraTabLateral.selecionarAnoSafra(anoSafra);
    // this.anoSafraService.getAnoSafra(anoSafraId).subscribe((res) => {
    //   const anoSafra = res;
    //   this.safraTabLateral.selecionarAnoSafra(anoSafra);
    // });
  }

  selecionarFazenda(fazenda: Fazenda) {
    this.fazenda = fazenda;
  }
  // listarPlanosAgronomico(): void{
  //   this.planejamentoService.getPlanejamentosPorAnoSafraCulturaFazenda(this.anoSafraSelecionada.Id, this.culturaSelecionada.Id, this.fazenda.Id)
  //   .subscribe(
  //     res => {
  //       console.debug("[listarPlanosAgronomico] listarPlanosAgronomico", res);
  //     }
  //   )
  // }
  exibirCarregamento(): void {
    if (this.gridTalhoes)
      this.gridTalhoes.showSpinner();

    this.carregando = true;
    this.desabilitarAcoes = true;

  }
  ocultarCarregamente(): void {
    if (this.gridTalhoes)
      this.gridTalhoes.hideSpinner();

    this.desabilitarAcoes = false;
    this.carregando = false;

  }
  listarPlanejamentos() {
    if (this.anoSafraSelecionada == null || !this.anoSafraSelecionada.Id)
      return;

    this.exibirCarregamento()
    this.planejamentoService
      .listarPorAnoSafraFazenda(
        this.anoSafraSelecionada.Id,
        this.fazenda.Id
      )
      .subscribe(
        (res) => {
          console.debug("[listarPlanejamentos] " + this.anoSafraSelecionada.Id + " | " + this.fazenda.Id, res.filter(p => p.Id != 0));
          this.prepararGrid();
          this.planejamentos = res.filter(p => p.Id != 0).map((p: Planejamento) => {
            p.DataPrevistaColheita = new Date(p.DataPrevistaColheita);
            p.DataPrevistaPlantio = new Date(p.DataPrevistaPlantio);
            return p;
          });
          this.auxPlanejamentos = this.planejamentos;

          this.areaTotalSafra = 0;
          this.planejamentos.forEach((p) => {
            p.DescricaoArea = this.getArea(p.AreaId).Descricao;
            this.areaTotalSafra += p.AreaPlantada;
            if (!p.DataRealPlantio) p.DataRealPlantio = p.DataPrevistaPlantio;
          });
          this.planejamentos.sort((a, b) =>
            a.DescricaoArea.localeCompare(b.DescricaoArea)
          );
          this.calculaLucroSafraTotal();
          this.ocultarCarregamente()
        },
        (err) => {
          this.utils.getErro(err);
          this.ocultarCarregamente()
        }
      );
  }

  doubleClick(event): void { }

  gerenciarTalhoes(): void {
    if (!this.utils.verificarPermissaoUsuario('GerenciarTalhoes'))
      return;
    if (this.talhoesComponent) {
      this.talhoesComponent.abrirModal();
    }
  }

  formatarDecimal(valor: number): string {
    return this.utils.formatarDecimais(valor);
  }

  editarPlanoAgronomico(): void {
    var talhoes = this.gridTalhoes.getSelectedRecords();
    if (talhoes.length == 0) {
      this.toasty.show(
        this.ATENCAO,
        "Nenhum talhão selecionado, selecione um para continuar",
        "warning"
      );
      return;
    } else if (talhoes.length > 1) {
      this.toasty.show(
        this.ATENCAO,
        "Vários talhões selecionados, selecione apenas um para continuar",
        "warning"
      );
      return;
    }

    this.configurar(talhoes[0]);
  }

  confirmRemoverTalhoes(): void {
    if (!this.utils.verificarPermissaoUsuario('GerenciarTalhoes'))
      return;
    var talhoes = this.gridTalhoes.getSelectedRecords();
    if (talhoes.length == 0) {
      this.utils.handleWarning("Selecione um ou mais para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os talhões selecionados serão removidos permanentemente. Essa ação é irreversível!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Remover talhões",
    }).then((response) => {
      if (!response.dismiss) {
        this.removerTalhoes(talhoes);
      }
    });
  }

  removerTalhoes(talhoes: Planejamento[]): void {
    this.desabilitarAcoes = true;
    this.removendo = true;
    const listaIds = talhoes.map((p) => p.Id);
    this.planejamentoService.deleteListaPlanejamento(listaIds).subscribe(
      (res: PlanejamentoDeleteListResponse) => {
        var html = "";
        const talhoesDeletados = this.planejamentos.filter((p) =>
          res.SuccessIds.includes(p.Id)
        );
        if (talhoesDeletados.length > 0)
          html += `<h4>Talhões excluidos:</h4>
          <b>${talhoesDeletados.map((t) => t.DescricaoArea).join(", ")}</b>`;

        if (res.Errors.length > 0) {
          var msgErro = "<h4>Talhões não excluidos:</h4> <br/>";
          msgErro += "<ul>";
          res.Errors.forEach((p) => {
            msgErro += `<li><b>${this.planejamentos.find((x) => x.Id == p.Id).DescricaoArea
              }</b>: ${p.Error}</li>`;
          });
          msgErro += "</ul>";
          html += msgErro;
        }

        console.debug("html: ", html);

        Swal.fire({
          html: html,
          type: "info",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
        this.removendo = false;
        this.desabilitarAcoes = false;
        this.listarPlanejamentos();
        this.atualizarAnoSafra();
      },
      (err) => {
        this.utils.getErro(err);
        this.removendo = false;
        this.desabilitarAcoes = false;
      }
    );
  }

  gerenciarProjetos(): void {
    if (!this.utils.verificarPermissaoUsuario('GerenciarProjetos'))
      return;
    this.listaProjetos.abrirModal(
      this.anoSafraSelecionada.Id
    );
  }

  confirmIniciarSelecionados(): void {
    if (!this.utils.verificarPermissaoUsuario('IniciarTalhoes'))
      return;
    var talhoes = this.gridTalhoes.getSelectedRecords();
    if (talhoes.length == 0) {
      this.utils.handleWarning("Selecione um ou mais para continuar");
      return;
    }

    // Verificar se algum talhão já está em andamento ou colhido
    const talhoesIniciados = talhoes.filter(talhao =>
      talhao.Status === 2 || talhao.Status === 3 // EmAndamento ou Colhido
    );

    if (talhoesIniciados.length > 0) {
      this.utils.handleWarning("Não é possível iniciar talhões que já estão em andamento ou colhidos");
      return;
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os talhões selecionados irão ser iniciados.",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Iniciar talhões",
    }).then((response) => {
      if (!response.dismiss) {
        this.iniciarSelecionados(talhoes);
      }
    });
  }
  iniciarSelecionados(talhoes: Planejamento[]): void {
    this.iniciandoTalhoes = true;
    this.planejamentoService
      .iniciarPlanejamentos(
        this.anoSafraSelecionada.Id,
        this.fazenda.Id,
        talhoes.map((t) => t.Id)
      )
      .subscribe(
        (res) => {
          this.utils.handleSuccess("Planejamentos iniciados com sucesso");
          this.atualizarAnoSafra();
          this.iniciandoTalhoes = false;
        },
        (err) => {
          this.utils.getErro(err);
          this.iniciandoTalhoes = false;
        }
      );
  }

  async atualizarAnoSafra(): Promise<void> {
    this.exibirCarregamento()
    await this.safraTabLateral.getAnosSafras()
    this.anosSafras = this.safraTabLateral.anosSafras
    this.anoSafraSelecionada = this.anosSafras.find(p => p.Id == this.anoSafraSelecionada.Id)
    this.listarPlanejamentos()
  }

  filtrar() {
    this.configurarTraducao();
    this.filtroStatusAtivo = this.POR_STATUS;

    if (this.filtroStatus == 1) this.filtroStatusAtivo = this.CONFIGURADOS;
    else if (this.filtroStatus == 2)
      this.filtroStatusAtivo = this.NAO_CONFIGURADOS;

    this.filtroAreaAtivo = this.POR_AREA;

    if (this.filtroArea > 0)
      this.filtroAreaAtivo = this.getArea(this.filtroArea).Descricao;

    this.filtroIrrigadoAtivo = this.POR_TIPO_DE_AREA;

    if (this.filtroIrrigado == 1) this.filtroIrrigadoAtivo = this.IRRIGADO;
    else if (this.filtroIrrigado == 2) this.filtroIrrigadoAtivo = this.SEQUEIRO;

    this.planejamentos = this.auxPlanejamentos.filter(
      (x) =>
        ((this.filtroStatus == 1 && x.QtdAtividades > 0) ||
          (this.filtroStatus == 2 && x.QtdAtividades <= 0) ||
          this.filtroStatus == 0) &&
        (x.AreaId == this.filtroArea || this.filtroArea == 0) &&
        (this.filtroIrrigado == 0 ||
          (this.filtroIrrigado == 1 && this.getArea(x.AreaId).Irrigado) ||
          (this.filtroIrrigado == 2 && !this.getArea(x.AreaId).Irrigado))
    );
  }

  filtrarStatus(status) {
    this.filtroStatus = status;
    this.filtrar();
  }

  filtrarArea(areaId) {
    this.filtroArea = areaId;
    this.filtrar();
  }

  filtrarIrrigado(irrigado) {
    this.filtroIrrigado = irrigado;
    this.filtrar();
  }

  limparFiltros() {
    this.filtroStatus = 0;
    this.filtroArea = 0;
    this.filtroIrrigado = 0;
    this.filtrar();
  }

  getArea(id: number): Area {
    if (!this.areas) return new Area();

    let area = this.areas.filter((x) => x.Id == id);

    return area.length > 0 ? area[0] : new Area();
  }

  getAreaPorFazenda(): Area[] {
    if (!this.areas || !this.fazenda) return [];

    let area = this.areas.filter((x) => x.FazendaId == this.fazenda.Id);

    return area;
  }

  getCultivar(id: number): Cultivar {
    if (!this.cultivares) return new Cultivar();

    let cultivar = this.cultivares.filter((x) => x.Id == id);

    return cultivar.length > 0 ? cultivar[0] : new Cultivar();
  }

  getCultura(id: number): Cultura {
    if (!this.culturas) return new Cultura();

    let cultura = this.culturas.filter((x) => x.Id == id);

    return cultura.length > 0 ? cultura[0] : new Cultura();
  }

  badgeStatusAnoSafra(): string {
    if (this.anoSafraSelecionada != undefined)
      switch (this.anoSafraSelecionada.Status) {
        case EnumStatusAnoSafra.Iniciado:
          return '<span class="badge badge-primary p-2">Em andamento</span>';
        case EnumStatusAnoSafra.Finalizado:
          return '<span class="badge badge-success p-2">Finalizado</span>';
        case EnumStatusAnoSafra.NaoIniciado:
          return '<span class="badge badge-secondary p-2">Não iniciado</span>';
      }
    else return "";
  }
  badgeStatusPlanejamento(status: EnumStatusPlanejmento): string {
    switch (status) {
      case EnumStatusPlanejmento.Colhido:
        return '<span class="badge badge-success badge-status-grid" style="">Colhido</span>';
      case EnumStatusPlanejmento.Configurada:
        return '<span class="badge badge-light badge-status-grid">Configurada</span>';
      case EnumStatusPlanejmento.EmAndamento:
        return '<span class="badge badge-warning badge-status-grid">Em andamento</span>';
      case EnumStatusPlanejmento.EmPlanejamento:
        return '<span class="badge badge-primary badge-status-grid">Em planejamento</span>';
      case EnumStatusPlanejmento.NaoConfigurdo:
        return '<span class="badge badge-secondary badge-status-grid">Não configurdo</span>';
    }
  }
  deletar(id: number, index: number, nome: string) {
    this.configurarTraducao();
    Swal.fire({
      title: "Deletar " + nome + "?",
      text: this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.planejamentoService.deletePlanejamento(id).subscribe(
          (res) => {
            this.planejamentoExcluido = this.planejamentos.filter(
              (p) => p.Id == id
            )[0];
            this.planejamentos.splice(index, 1);
          },
          (err) => {
            this.utils.getErro(err);
            this.carregando = false;
          }
        );
      }
    });
  }

  simular(planejamento: Planejamento) {
    this.isSubmit = false;
    this.planejamentoSimulado = new Planejamento();
    this.planejamentoSimulado.Id = planejamento.Id;
    this.planejamentoSimulado.CustoPorHA = planejamento.CustoPorHA;
    this.planejamentoSimulado.ProdutividadeSimulada =
      planejamento.ProdutividadeSimulada;
    this.planejamentoSimulado.PrecoVendaSimulado =
      planejamento.PrecoVendaSimulado;
    this.planejamentoSimulado.LucroSimulado = planejamento.LucroSimulado;
    this.ModalSimular.show();
  }

  confirmarSimulacao(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }

    let planejamento = this.planejamentos.filter(
      (p) => p.Id == this.planejamentoSimulado.Id
    )[0];

    this.calculaLucro();
    planejamento.ProdutividadeSimulada =
      this.planejamentoSimulado.ProdutividadeSimulada;
    planejamento.PrecoVendaSimulado =
      this.planejamentoSimulado.PrecoVendaSimulado;
    planejamento.LucroSimulado = this.planejamentoSimulado.LucroSimulado;

    this.carregando = true;
    this.planejamentoService
      .putPlanejamento(this.planejamentoSimulado.Id, planejamento)
      .subscribe(
        (res) => {
          this.ModalSimular.hide();
          this.carregando = false;
        },
        (err) => {
          this.utils.getErro(err);
          this.carregando = false;
        }
      );
  }

  calculaLucro() {
    this.planejamentoSimulado.LucroSimulado =
      this.planejamentoSimulado.ProdutividadeSimulada *
      this.planejamentoSimulado.PrecoVendaSimulado -
      this.planejamentoSimulado.CustoPorHA;
  }

  simularSafra() {
    this.isSubmit = false;
    this.calculaLucroSafraTotal();
    this.ModalSimularSafra.show();
  }

  gerarOsSafra() {
    this.configurarTraducao();
    this.isSubmit = false;
    if (!this.safraSelecionada || !this.planejamentos) return;

    Swal.fire({
      title: this.GERAR_TODAS_OS_DESSA_SAFRA,
      text: this
        .ESSA_ACAO_PODERA_LEVAR_UM_TEMPO_E_SUBSTITUIR_AS_OS_JA_EXISTENTES,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.carregando = true;
        this.ordemServicoService
          .gerarOrdemServicoPorSafra(this.safraSelecionada.Id)
          .subscribe(
            (res) => {
              this.carregando = false;
              this.toasty.show(
                this.OS_GERADAS_COM_SUCESSO,
                this.TODAS_AS_OS_DESSA_SAFRA_FORAM_GERADAS,
                "success"
              );
            },
            (err) => {
              this.utils.getErro(err);
              this.carregando = false;
            }
          );
      }
    });
  }

  excluirOsSafra() {
    this.configurarTraducao();
    this.isSubmit = false;
    if (!this.safraSelecionada || !this.planejamentos) return;

    Swal.fire({
      title: this.DELETAR_TODAS_OS_DESSA_SAFRA,
      text: this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.carregando = true;
        this.ordemServicoService
          .deleteOrdemServicoPorSafra(this.safraSelecionada.Id)
          .subscribe(
            (res) => {
              this.carregando = false;
              this.toasty.show(
                this.OS_EXCLUIDAS_COM_SUCESSO,
                this.TODAS_AS_OS_DESSA_SAFRA_FORAM_EXCLUIDAS,
                "success"
              );
            },
            (err) => {
              this.utils.getErro(err);
              this.carregando = false;
            }
          );
      }
    });
  }

  timoutSafra: any;
  calculaLucroSafra(planejamento: Planejamento) {
    if (this.timoutSafra) clearTimeout(this.timoutSafra);

    this.timoutSafra = setTimeout(() => {
      if (planejamento) this.atualizaSimulacao(planejamento);
      else {
        this.planejamentos.forEach((p) => {
          p.ProdutividadeSimulada = this.safraSelecionada.ProdutividadeSimulada;
          p.PrecoVendaSimulado = this.safraSelecionada.PrecoVendaSimulado;

          this.atualizaSimulacao(p);
        });
      }

      this.calculaLucroSafraTotal();
    }, 300);
  }

  atualizaSimulacao(planejamento: Planejamento) {
    planejamento.LucroSimulado =
      planejamento.ProdutividadeSimulada * planejamento.PrecoVendaSimulado -
      planejamento.CustoPorHA;

    this.planejamentoService
      .putPlanejamento(planejamento.Id, planejamento)
      .subscribe(
        (res) => { },
        (err) => {
          this.utils.getErro(err);
        }
      );
  }

  calculaLucroSafraTotal() {
    if (!this.safraSelecionada || !this.planejamentos) return;

    this.safraSelecionada.AreaTotal = 0;
    this.safraSelecionada.LucroSimulado = 0;
    this.safraSelecionada.CustoPorHA = 0;
    this.safraSelecionada.PrecoVendaSimulado = 0;
    this.safraSelecionada.ProdutividadeSimulada = 0;

    let custoTotal = 0;
    let produtividadeTotal = 0;
    let precoTotal = 0;
    let lucroTotal = 0;

    this.planejamentos
      .filter((p) => p.LucroSimulado != 0)
      .forEach((p) => {
        lucroTotal += p.LucroSimulado * p.AreaPlantada;
        custoTotal += p.CustoPorHA * p.AreaPlantada;
        produtividadeTotal += p.ProdutividadeSimulada * p.AreaPlantada;
        precoTotal += p.PrecoVendaSimulado * p.AreaPlantada;

        this.safraSelecionada.AreaTotal += p.AreaPlantada;
      });

    this.safraSelecionada.ProdutividadeSimulada =
      produtividadeTotal / this.safraSelecionada.AreaTotal;
    this.safraSelecionada.PrecoVendaSimulado =
      precoTotal / this.safraSelecionada.AreaTotal;
    this.safraSelecionada.CustoPorHA =
      custoTotal / this.safraSelecionada.AreaTotal;
    this.safraSelecionada.LucroSimulado =
      lucroTotal / this.safraSelecionada.AreaTotal;
    this.safraSelecionada.LucroTotalSimulado =
      this.safraSelecionada.LucroSimulado * this.safraSelecionada.AreaTotal;
  }

  replicarProdutividade(planejamento: Planejamento) {
    this.planejamentos
      .filter((p) => p.CultivarId == planejamento.CultivarId)
      .forEach((p) => {
        p.ProdutividadeSimulada = planejamento.ProdutividadeSimulada;
        this.atualizaSimulacao(p);
      });

    this.calculaLucroSafraTotal();
  }

  replicarPrecoVenda(planejamento: Planejamento) {
    this.planejamentos
      .filter((p) => p.CultivarId == planejamento.CultivarId)
      .forEach((p) => {
        p.PrecoVendaSimulado = planejamento.PrecoVendaSimulado;
        this.atualizaSimulacao(p);
      });

    this.calculaLucroSafraTotal();
  }

  configurar(planejamento: Planejamento) {
    if (!planejamento.PlanoMestreProducaoId) {
      this.isSubmit = false;
      this.planejamentoConfigurado = planejamento;
      this.carregando = true;
      this.planejamentoService
        .getPlanosMestrePorCultura(this.safraSelecionada.CulturaId)
        .subscribe((ret) => {
          this.planosMestre = ret;
          this.planosMestre = this.planosMestre.filter(
            (p) =>
              p.CultivarId == planejamento.CultivarId && p.QtdAtividades > 0
          );
          this.carregando = false;
          this.ModalConfigurar.show();
        });
    } else {
      localStorage.setItem('ultimoAnoSafraSelecionado', this.anoSafraId.toString());
      this.router.navigate([
        "/planejamento/safra/planejamento/" + planejamento.Id,
      ]);
    }
  }

  confirmarConfiguracao(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }

    this.carregando = true;
    this.planejamentoService
      .putPlanejamento(
        this.planejamentoConfigurado.Id,
        this.planejamentoConfigurado
      )
      .subscribe(
        (res) => {
          this.ModalConfigurar.hide();
          this.carregando = false;

          this.router.navigate([
            "/planejamento/safra/planejamento/" +
            this.planejamentoConfigurado.Id,
          ]);
        },
        (err) => {
          this.utils.getErro(err);
          this.carregando = false;
        }
      );
  }

  alterarEdicaoSafra(mostrar: boolean) {
    this.mostraEdicaoSafra = mostrar;
    this.listarPlanejamentos();
  }

  changeDataPlantio(area: Planejamento, dataPrevisao: Date) {
    if (dataPrevisao) {
      area.DataRealPlantio = dataPrevisao;
      area.FlagPlantou = true;
      this.ConfirmarPlantio(area);
    }
  }

  ConfirmarPlantio(area: Planejamento) {
    this.configurarTraducao();
    setTimeout(() => {
      if (area.FlagPlantou)
        this.planejamentoService.putPlanejamento(area.Id, area).subscribe(
          (ret) => {
            this.toasty.show(this.FEITO, this.PLANTIO_ENCERRADO, "success");
          },
          (err) => {
            this.utils.getErro(err);
            this.carregando = false;
          }
        );
    }, 300);
  }

  RedirecionarOS() {
    this.configurarTraducao();
    Swal.fire({
      title: this.ACESSAR_ORDENS_DE_SERVICO,
      text: this.VOCE_SERA_REDIRECIONADO_PARA_A_TELA_DE_ORDENS_DE_SERVICO_,
      type: "success",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.NAO,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.router.navigate([
          "/ordem-servico/detalhamento/safra/" + this.safraSelecionada.Id,
        ]);
      }
    });
  }

  configurarTraducao() {
    this.SIM = this.translate.instant("SIM");
    this.NAO = this.translate.instant("NAO");
    this.VOCE_SERA_REDIRECIONADO_PARA_A_TELA_DE_ORDENS_DE_SERVICO_ =
      this.translate.instant(
        "VOCE_SERA_REDIRECIONADO_PARA_A_TELA_DE_ORDENS_DE_SERVICO_"
      );
    this.ACESSAR_ORDENS_DE_SERVICO = this.translate.instant(
      "ACESSAR_ORDENS_DE_SERVICO"
    );
    this.ORDENS_DE_SERVICO_GERADAS_COM_SUCESSO = this.translate.instant(
      "ORDENS_DE_SERVICO_GERADAS_COM_SUCESSO"
    );
    this.TODAS_AS_ORDENS_DE_SERVICO_DESSA_SAFRA_FORAM_GERADAS =
      this.translate.instant(
        "TODAS_AS_ORDENS_DE_SERVICO_DESSA_SAFRA_FORAM_GERADAS"
      );
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.AO_INICIAR_A_SAFRA_TODAS_AS_ORDENS_DE_SERVICO_SERAO_GERADAS_BASEADO_NOS_DIAS_DE_REFERENCIA_E_NA_PREVISAO_DE_PLANTIO_DESEJA_CONTINUAR =
      this.translate.instant(
        "AO_INICIAR_A_SAFRA_TODAS_AS_ORDENS_DE_SERVICO_SERAO_GERADAS_BASEADO_NOS_DIAS_DE_REFERENCIA_E_NA_PREVISAO_DE_PLANTIO_DESEJA_CONTINUAR"
      );
    this.INICAR_SAFRA = this.translate.instant("INICAR_SAFRA");
    this.SAFRA_JA_INICIADA = this.translate.instant("SAFRA_JA_INICIADA");
    this.ATENCAO = this.translate.instant("ATENCAO");
    this.NENHUMA_SAFRA_SELECIONADA = this.translate.instant(
      "NENHUMA_SAFRA_SELECIONADA"
    );
    this.PLANTIO_ENCERRADO = this.translate.instant("PLANTIO_ENCERRADO");
    this.FEITO = this.translate.instant("FEITO");
    this.OS_EXCLUIDAS_COM_SUCESSO = this.translate.instant(
      "OS_EXCLUIDAS_COM_SUCESSO"
    );
    this.TODAS_AS_OS_DESSA_SAFRA_FORAM_EXCLUIDAS = this.translate.instant(
      "TODAS_AS_OS_DESSA_SAFRA_FORAM_EXCLUIDAS"
    );
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant(
      "SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA"
    );
    this.DELETAR_TODAS_OS_DESSA_SAFRA = this.translate.instant(
      "DELETAR_TODAS_OS_DESSA_SAFRA"
    );
    this.OS_GERADAS_COM_SUCESSO = this.translate.instant(
      "OS_GERADAS_COM_SUCESSO"
    );
    this.TODAS_AS_OS_DESSA_SAFRA_FORAM_GERADAS = this.translate.instant(
      "TODAS_AS_OS_DESSA_SAFRA_FORAM_GERADAS"
    );
    this.ESSA_ACAO_PODERA_LEVAR_UM_TEMPO_E_SUBSTITUIR_AS_OS_JA_EXISTENTES =
      this.translate.instant(
        "ESSA_ACAO_PODERA_LEVAR_UM_TEMPO_E_SUBSTITUIR_AS_OS_JA_EXISTENTES"
      );
    this.GERAR_TODAS_OS_DESSA_SAFRA = this.translate.instant(
      "GERAR_TODAS_OS_DESSA_SAFRA"
    );
    this.SEQUEIRO = this.translate.instant("SEQUEIRO");
    this.IRRIGADO = this.translate.instant("IRRIGADO");
    this.POR_TIPO_DE_AREA = this.translate.instant("POR_TIPO_DE_AREA");
    this.POR_AREA = this.translate.instant("POR_AREA");
    this.NAO_CONFIGURADOS = this.translate.instant("NAO_CONFIGURADOS");
    this.CONFIGURADOS = this.translate.instant("CONFIGURADOS");
    this.POR_STATUS = this.translate.instant("POR_STATUS");
  }

}
